import { render, staticRenderFns } from "./ManageFeedbacks.vue?vue&type=template&id=cb31626a&"
import script from "./ManageFeedbacks.vue?vue&type=script&lang=js&"
export * from "./ManageFeedbacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports